/* eslint-disable-next-line default-param-last */
export const sortArrayIntoColumns = (columnCount = 1, array : Array<unknown>)
: Array<Array<unknown>> => {
  if (columnCount === 1) {
    return [array];
  }
  if (columnCount === 2) {
    const half = Math.round(array.length / 2);
    const firstColum = array.slice(0, half);
    const secondColumn = array.slice(half, array.length);

    return [firstColum, secondColumn];
  }
  const third = Math.round(array.length / 3);

  const rest = array.slice((third * 2), array.length).length;
  let firstColum = array.slice(0, third);
  let secondColumn = array.slice(third, (third * 2));
  let thirdColumn = array.slice((third * 2), array.length);

  if (rest > third) {
    firstColum = array.slice(0, third + 1);
    secondColumn = array.slice(third + 1, (third * 2 + 1));
    thirdColumn = array.slice((third * 2) + 1, array.length);
  }

  return [firstColum, secondColumn, thirdColumn];
};
